import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AutoSignup from '../components/pages/AccountMigration/AutoSignup';
import { validateActivationToken } from '../actions/authActions';
import queryString from 'query-string';
import Footer from '../components/blocks/Footer';
import PageWithFooter from '../components/blocks/PageWithFooter';
import { clearNotificationMessage } from '../actions/notificationActions';
import { ThemeProvider } from '@emotion/react';
import { WYPTheme } from 'swui';
import useModal from '../hooks/useModal';
import _isEmpty from 'lodash/isEmpty';
import HeaderOut from '../atoms/HeaderOut';
import styled from '@emotion/styled';
import Button from '../atoms/buttons/Button';
import { loadGoogleMaps } from '../utils/helpers';
import { useNavigate } from 'react-router-dom';
import breakpoints from '../theme/material/breakpoints';
import { AppDispatch, RootState } from '../store';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

const SuccessHeader = styled('h3')({
  color: '#000',
});

const CopyTextContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  height: 50,
});

const LinkToProfile = styled('a')({
  color: '#2B8FD7',
  fontWeight: 600,
  '&:hover': {
    borderBottom: '1px solid #2B8FD7',
  },
});
const StyledFooter = styled(Footer)({
  [breakpoints.down('sm')]: {
    position: 'relative',
  },
});

interface AutoSignupProps {
  location: any;
  validateMigrateToken: any;
  asyncValidateMigrateToken: any;
  isFetching: any;
  errors: any;
  profile: any;
}

const AutoSignupContainer = ({ location, asyncValidateMigrateToken, isFetching, errors, profile }: AutoSignupProps) => {
  const { basicModal, resetModal } = useModal();
  const [migrationInfo, setMigrationInfo] = useState(null);
  const queryStringParsed = queryString.parse(location.search);
  const { isMobile } = useMediaBreakpoints();
  const navigate = useNavigate();

  useEffect(() => {
    if (queryStringParsed) {
      const { token } = queryStringParsed;

      loadGoogleMaps();
      setTimeout(() => {
        asyncValidateMigrateToken(token)
          .then(asyncRes => {
            setMigrationInfo(asyncRes);
          })
          .catch(err => console.error(err));
      }, 1500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (profile?.hash_id && !_isEmpty(migrationInfo)) {
      showSuccessModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  const showSuccessModal = () => {
    const profileLink = profile?.hash_id ? `/profile/${profile.hash_id}?migration_edit=true` : '/profile';

    basicModal({
      dataTestID: 'profile-success-creation',
      modalContentLabel: 'Profile successfully created!',
      withoutBgPattern: true,
      customContentStyle: { width: 540, padding: isMobile ? 12 : '12px 44px' },
      hideCloseBtn: true,
      closeOnOverlayClick: false,
      modalBody: (
        <div style={{ textAlign: 'center' }}>
          <HeaderOut paddingTop={20} width={isMobile ? 260 : 340} />
          <SuccessHeader>Profile successfully created!</SuccessHeader>
          <p>
            Continue <LinkToProfile href={profileLink}>making edits</LinkToProfile> or start finding your next date!
          </p>
          <CopyTextContainer>
            <Button
              customStyle={{ fontSize: isMobile ? 14 : 16 }}
              buttonType="primaryRed"
              onClick={() => {
                resetModal();
                navigate('/search');
              }}
            >
              Browse Members
            </Button>
          </CopyTextContainer>
        </div>
      ),
    });
  };

  return (
    <ThemeProvider theme={WYPTheme}>
      <div id="main">
        <PageWithFooter customMobileStyles={{ paddingBottom: 25 }}>
          <AutoSignup isFetching={isFetching} errors={errors} />
        </PageWithFooter>
        <StyledFooter />
      </div>
    </ThemeProvider>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    errors: state.common.errors,
    isFetching: state.common.isFetching,
    notification: state.notification,
    profile: state.profile,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: RootState) => {
  return {
    clearNotificationMessage() {
      dispatch(clearNotificationMessage());
    },
    loadPageUrl(linkUrl) {
      dispatch(clearNotificationMessage());
      ownProps.navigate(linkUrl);
    },
    validateMigrateToken: token => {
      dispatch(validateActivationToken(token));
    },
    asyncValidateMigrateToken: async token => {
      return await dispatch(validateActivationToken(token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoSignupContainer);
